"use client";
import { jsx as t, Fragment as h } from "react/jsx-runtime";
import { isSSR as b } from "../../common/helpers/isSSR.js";
import { useSkfUiContext as g } from "../../common/hooks/useSkfUiContext.js";
import { useMounted as v } from "../../hooks/useMounted.js";
import { forwardRef as A } from "react";
import w from "react-dom";
const s = A(
  ({ children: r, feAppId: m, feAppInert: c = !1, feRender: d = !0, feTarget: n, ...o }, i) => {
    const a = g();
    if (b())
      return /* @__PURE__ */ t("div", { ...o, "data-comp": "portal", ref: i, children: r });
    const e = m ? document.getElementById(m) : a, u = n ? document.querySelector(n) : e == null ? void 0 : e.parentNode, l = v(), f = () => {
      e != null && e.hasAttribute("inert") && (e == null || e.removeAttribute("aria-hidden"), e == null || e.removeAttribute("inert"));
    };
    return !(u instanceof Element) && !(u instanceof DocumentFragment) ? (console.error(
      `The portal component requires a target Element or DocumentFragment in the document to know where to render.
				You might get this error message because the feTarget [${n}] (which is the parent of feAppRoot ${a ? "[exists]" : "[not found either! :( ]"}) can't be found
				in the DOM or because your app root doesn't have a parent.
				`
    ), null) : d ? (c ? (e == null || e.setAttribute("aria-hidden", "true"), e == null || e.setAttribute("inert", "true")) : f(), l ? /* @__PURE__ */ t(h, { children: w.createPortal(
      /* @__PURE__ */ t("div", { ...o, "data-comp": "portal", ref: i, children: r }),
      u
    ) }) : /* @__PURE__ */ t("div", { ...o, "data-comp": "portal", ref: i, children: r })) : null;
  }
);
s.displayName = "Portal";
const F = s;
export {
  F as default
};
